import Vue from "vue";
import VueRouter from "vue-router";
import ArtistPage from "../views/ArtistPage.vue";
const Exhibition = () =>
  import(/* webpackChunkName: "common" */ "@/views/Exhibition.vue");

const ExploreArt = () =>
  import(/* webpackChunkName: "common" */ "@/views/ExploreArt.vue");

const OurArtists = () =>
  import(/* webpackChunkName: "common" */ "@/views/OurArtists.vue");

const Login = () =>
  import(
    /* webpackChunkName: "common" */ "@/components/authentication/Login.vue"
  );

const ArtStories = () =>
  import(/* webpackChunkName: "common" */ "@/views/ArtStory.vue");

const ArtStory = () =>
  import(
    /* webpackChunkName: "common" */ "@/components/ArtStoryComponents/ArtStoryDetail.vue"
  );

const ThreeDGallery = () =>
  import(/* webpackChunkName: "common" */ "@/views/Three-d.vue");

const Home = () =>
  import(/* webpackChunkName: "common" */ "@/views/HomePage.vue");

const ArtistsHomepage = () =>
  import(/* webpackChunkName: "common" */ "@/views/ArtistsHomepage.vue");

const Checkout = () =>
  import(/* webpackChunkName: "common" */ "@/views/Checkout.vue");

const LandingPageNew = () =>
  import(/* webpackChunkName: "common" */ "@/views/LandingPageNew.vue");

const MyAccount = () =>
  import(/* webpackChunkName: "common" */ "@/views/MyAccount.vue");

const OrderDetails = () =>
  import(
    /* webpackChunkName: "common" */ "@/components/common/OrderDetails.vue"
  );
// const ArtistPlan = () =>
//   import(
//     /* webpackChunkName: "common" */ "@/views/ArtistPlan.vue"
//   );

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "LandingPageNew",
    component: LandingPageNew,
  },
  {
    path: "/home/",
    name: "Home",
    component: Home,
  },
  {
    path: "/login/",
    name: "Login",
    component: Login,
  },
  {
    path: "/exhibition/",
    name: "Exhibition",
    component: Exhibition,
  },
  {
    path: "/explore-art/",
    name: "ExploreArt",
    component: ExploreArt,
  },
  {
    path: "/premium-art/",
    name: "PremiumArt",
    component: ExploreArt,
  },
  {
    path: "/latest-art/",
    name: "LatestArt",
    component: ExploreArt,
  },
  // {
  //   path: "/our-artists/",
  //   name: "OurArtists",
  //   component: OurArtists,
  // },

  // {
  //   path: "/art-stories/",
  //   name: "ArtStories",
  //   component: ArtStories
  // },

  // {
  //   path: "/art-story/:art_story_slug/",
  //   name: "ArtStory",
  //   component: ArtStory
  // },
  {
    path: "/order-details/:order_id/",
    name: "OrderDetails",
    component: OrderDetails,
    meta: { requiresAuth: true }
  },
  {
    path: "/artist/:artist_slug/",
    name: "ArtistPage",
    component: ArtistPage,
  },
  {
    path: "/artists-home/",
    name: "ArtistsHomepage",
    component: ArtistsHomepage,
  },
  {
    path: "/three-d/",
    name: "ThreeD",
    component: ThreeDGallery,
  },
  {
    path: "/logout/",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/authentication/Logout.vue"
      ),
      meta: { requiresAuth: true }
  },
  {
    path: "/remove-authentication/",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/authentication/RemoveAuthentication.vue"
      ),
  },
  {
    path: "/checkout/",
    name: "Checkout",
    component: Checkout,
  },
  {
    path: "/myaccount/",
    name: "MyAccount",
    component: MyAccount,
    meta: { requiresAuth: true },
  },
  {
    path: "/success/",
    name: "Success",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/common/Successful.vue"
      ),
      meta: { requiresAuth: true }
  },
  {
    path: "/unsuccess/",
    name: "Unsuccess",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/common/Unsuccessful.vue"
      ),
      meta: { requiresAuth: true }
  },
  {
    path: "/frame/",
    name: "FrameCustomization",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/common/NewFrame.vue"
      ),
  },
  // {
  //   path: "/artist/",
  //   name: "ArtistPlan",
  //   component: ArtistPlan,
  //   meta: { requiresAuth: true }
  // },
  {
    path: "/terms/",
    name: "Terms",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/common/TermOfUse.vue"
      ),
  },
  {
    path: "/privacy/",
    name: "Privacy",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/common/PrivacyPolicy.vue"
      ),
  },
  {
    path: '*',
    component: LandingPageNew,
},

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
